
import React, { useState } from 'react';
import workouts from './workouts'; // Import the workout library


const GuidedWorkoutExecutor = () => {
  const [workoutProgram, setWorkoutProgram] = useState([
    { day: 'Day 1', exercises: [{ name: 'squat', sets: 3, reps: 8, weight: { value: 100, unit: 'kg' }, tempo: [2, 0, 1, 0], expanded: false }, { name: 'benchPress', sets: 4, reps: 6, weight: { value: 100, unit: 'kg' }, tempo: [2, 0, 1, 0], expanded: false }] },
    { day: 'Day 2', exercises: [{ name: 'pullUp', sets: 3, reps: 10, weight: { value: 100, unit: 'kg' }, tempo: [2, 0, 1, 0], expanded: false }, { name: 'deadlift', sets: 3, reps: 5, weight: { value: 100, unit: 'kg' }, tempo: [2, 0, 1, 0], expanded: false }] },
  ]);

  const [currentDayIndex, setCurrentDayIndex] = useState(0);
  const [currentExerciseIndex, setCurrentExerciseIndex] = useState(-1); // -1 means showing day intro
  const [completedExercises, setCompletedExercises] = useState([]);
  const [exerciseNotes, setExerciseNotes] = useState({});

  const motivationalQuotes = [
    "The only bad workout is the one that didn't happen.",
    "Your body can stand almost anything. It's your mind that you have to convince.",
    "The pain you feel today will be the strength you feel tomorrow.",
    "Strength does not come from the physical capacity. It comes from an indomitable will.",
    "The hardest lift of all is lifting your butt off the couch.",
  ];

  const getCurrentQuote = () => {
    const randomIndex = Math.floor(Math.random() * motivationalQuotes.length);
    return motivationalQuotes[randomIndex];
  };

  const handleExerciseComplete = (success) => {
    const exerciseId = `${currentDayIndex}-${currentExerciseIndex}`;
    const notes = exerciseNotes[exerciseId] || '';
    
    setCompletedExercises([...completedExercises, { 
      id: exerciseId, 
      success,
      notes
    }]);
    
    // Move to next exercise or next day
    const currentDay = workoutProgram[currentDayIndex];
    if (currentExerciseIndex < currentDay.exercises.length - 1) {
      setCurrentExerciseIndex(currentExerciseIndex + 1);
    } else if (currentDayIndex < workoutProgram.length - 1) {
      setCurrentDayIndex(currentDayIndex + 1);
      setCurrentExerciseIndex(-1); // Show day intro
    } else {
      // Workout program completed
      setCurrentDayIndex(-1); // Show completion screen
    }
  };

  const handleNotesChange = (notes) => {
    const exerciseId = `${currentDayIndex}-${currentExerciseIndex}`;
    setExerciseNotes({
      ...exerciseNotes,
      [exerciseId]: notes
    });
  };

  if (currentDayIndex === -1) {
    // Workout program completion screen
    return (
      <div className="guided-view completion">
        <h1>Congratulations!</h1>
        <p>You've completed the entire workout program.</p>
        <button onClick={() => {
          setCurrentDayIndex(0);
          setCurrentExerciseIndex(-1);
          setCompletedExercises([]);
        }}>
          Start Again
        </button>
      </div>
    );
  }

  const currentDay = workoutProgram[currentDayIndex];

  if (currentExerciseIndex === -1) {
    // Day introduction screen
    return (
      <div className="guided-view day-intro">
        <h1>Starting {currentDay.day}!</h1>
        <p className="quote">"{getCurrentQuote()}"</p>
        <button className="start-button" onClick={() => setCurrentExerciseIndex(0)}>
          Let's Begin
        </button>
      </div>
    );
  }

  const currentExercise = currentDay.exercises[currentExerciseIndex];
  
  return (


    <div className="guided-view exercise-view">
      <h2>{currentDay.day} - Exercise {currentExerciseIndex + 1} of {currentDay.exercises.length}</h2>
      
      <div className="exercise-card card">
        <div className="exercise-image">
          <video src="https://storage.googleapis.com/heldsolutionsllc-public-bucket/workoutmedia/squat-001.mp4" 
          controls autoPlay loop muted 
          height="200"
          />
          {/* <img src="https://via.placeholder.com/300x200?text=Exercise+Image" alt={workouts[currentExercise.name].name} /> */}
        </div>
        
        <h3>{workouts[currentExercise.name].name}</h3>
        
        <div className="exercise-details">
          <strong>Sets:</strong> {currentExercise.sets}
          <strong>Reps:</strong> {currentExercise.reps}
          <strong>Weight:</strong> {currentExercise.weight.value} {currentExercise.weight.unit}
                    <strong>Tempo:</strong> {currentExercise.tempo.join('/')}
          {currentExercise.notes && <><strong>Instructions:</strong> {currentExercise.notes}</>}
        </div>

        <div className="exercise-notes">
          <h4>Your Notes</h4>
          <textarea
            placeholder="Write your notes about this exercise (how it felt, any difficulties, etc.)"
            value={exerciseNotes[`${currentDayIndex}-${currentExerciseIndex}`] || ''}
            onChange={(e) => handleNotesChange(e.target.value)}
            rows={4}
          />
        </div>
        
        <div className="exercise-actions">
          <button className="complete-button" onClick={() => handleExerciseComplete(true)}>
            Completed!
          </button>
          <button className="failed-button" onClick={() => handleExerciseComplete(false)}>
            Failed
          </button>
        </div>
      </div>
    </div>



  );
};


export default GuidedWorkoutExecutor;